import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';

import { URL } from 'bundles/constants';
import If from 'bundles/components/common/If';

const CookieConsentComponent = () => {
  const { t } = useTranslation();
  const current_environment = process.env.RAILS_ENV;

  return (
    <If condition={current_environment !== 'ui_test'}>
      <CookieConsent
        cookieName="cookieConsent"
        style={{ background: 'rgba(0, 33, 93, 0.95)' }}
        buttonClasses="btn btn-primary"
        buttonStyle={{ background: 'var(--primary)', color: 'var(--white)', padding: '1.2rem 2.4rem', borderRadius: '.6rem' }}
        ButtonComponent={(ref: Record<string, any>) =>
          (
            <>
              <a className="btn btn-primary cookies-settings-button" tabIndex={0} href={URL.COOKIE_SETTINGS} rel="noopener noreferrer nofollow">
                {t('public.cookie_settings.change_settings')}
              </a>
              <button {...ref}>{t('public.cookie_settings.agreement')}</button>
            </>
          )
        }
      >
        {t('cookieconsent.message')}
        {' '}
        <a aria-label="learn more about cookies" tabIndex={0} href={URL.COOKIE_POLICY} rel="noopener noreferrer nofollow" target="_blank">
          {t('cookieconsent.link')}
        </a>
      </CookieConsent>
    </If>
  );
};

export default CookieConsentComponent;
